
export default {
  props: {
    url: { type: String, required: true }
  },
  computed: {
    jsonld () {
      return {
        '@context': 'https://schema.org/',
        '@type': 'ImageObject',
        contentUrl: this.url,
        license: 'https://infodiagram.com/contact/#terms',
        acquireLicensePage: 'https://infodiagram.com/contact/#terms',
        creditText: 'download at infodiagram.com',
        creator: {
          '@type': 'Organization',
          name: 'infoDiagram Ltd'
        },
        copyrightNotice: 'infoDiagram Ltd'
      }
    }
  }
}
